import type { Types } from '../../types';
import type { ConnectedTypes } from '../../make-connected';

export function parseSettings (settings: ConnectedTypes.divisionSettings): Types.Entities.Settings {

  if (!settings.numDays)        throw new Error('(RS::To::parseSettings) numDays is falsy');
  if (!settings.discretization) throw new Error('(RS::To::parseSettings) discretization is falsy');

  return {
    numDays:        settings.numDays,
    discretization: settings.discretization,
  };
};